// UI
import ComponentCover from "@hitit/hub/src/v7/components/common/ComponentLoading.svelte"

// Utils
import { api as __api__ } from "@hitit/hub/src/stores"
import { putS3File } from "@hitit/api";
import { get } from "svelte/store";
import { v4 } from "uuid"
// Types
import type { ActiveEditor } from "../../types";

export async function completedUploadCallback(e: Event, editor: ActiveEditor) {
    const tox = document.querySelector(".tinymce-wrapper") as HTMLDivElement
    const loading = new ComponentCover({ props: { coverMode: true }, target: tox })
    try {
        const IMAGE_URL = "HITIT_IMAGE_URL";
        const api = get(__api__);
        const target = e.target as HTMLInputElement;
        const fileInfo = exportExactFile(target);


        if (fileInfo === null) return;

        const fileUploadResponse = await api.getFileUploadUrl({
            fileName: fileInfo.name,
            fileType: fileInfo.type,
            objectPurpose: "PUBLIC_ARTICLE",
        });
        const { url, id } = fileUploadResponse.data;
        const __id__ = id.split("|")[2]
        await putS3File(url, fileInfo.file);

        const imageURL = IMAGE_URL + __id__
        await delay(1000);
        const { width } = await getImageFilSize(fileInfo.file)

        editor.insertContent(
            `<figure><img class="user-import" width="${width}px" src="${imageURL}"/></figure>`
        );

    } catch (error) {
        console.log(error)
    } finally {
        loading.$destroy()
    }
}

function exportExactFile(target: HTMLInputElement) {
    const fileLength = target.files?.length || 0;

    if (fileLength !== 1) return null

    const file = target.files![0]
    const extMatch = file.name.match(
        /(\.png|\.jpg|\.jpeg|\.JPG|\.JPEG|\.PNG)$/
    );
    if (!extMatch) return null;
    const ext = extMatch[1].replace(".", "");
    const reg = new RegExp("-", "g");
    const name = v4().replace(reg, "")

    return {
        file: file,
        name: name,
        type: ext.toUpperCase(),
    }
}

async function delay(milSecond: number) {
    return new Promise((resolve) => {
        setTimeout(() => { resolve("") }, milSecond)
    })
}

function getImageFilSize(file: File): Promise<{ width: number, height: number }> {

    return new Promise((res, rej) => {
        const url = URL.createObjectURL(file);
        const image = new Image();
        image.src = url
        image.onload = () => {
            const width = image.width
            const height = image.height;
            URL.revokeObjectURL(url)

            res({
                width,
                height
            })
        }
    })
}
